import store from '@/store';
import { createAddressRepository } from '@/forms/api/repository-factory';
import getValueByFieldName from '@/forms/helpers/get-value-by-field-name';
import FIELD_NAMES from '@/forms/constants/field-names';
import STEP_NAMES from '@/forms/constants/step-names'
import callApi from '@/lib/helpers/call-api';
import {

    SET_ADDRESS_COUNT,

} from "@/lib/constants/mutations";
const getPayload = () => {
    const { values } = store.state.formData;
    const { cifnumber, } = store.state;
    let step = store.state.formData.currentStepName
    let addressTypeBusiness = getValueByFieldName(values, FIELD_NAMES.primaryAddress);
    let addressTypeHome = getValueByFieldName(values, FIELD_NAMES.homeAddress);
    //BUSINESS ADDRESS
    const address1 = getValueByFieldName(values, FIELD_NAMES.addressLine1);
    const address2 = getValueByFieldName(values, FIELD_NAMES.addressLine2);
    const landmark = getValueByFieldName(values, FIELD_NAMES.nearestLandmark);
    const emirates = getValueByFieldName(values, FIELD_NAMES.residentialEmirate);
    const country = getValueByFieldName(values, FIELD_NAMES.homeCountryCountry);
    const pinCode = getValueByFieldName(values, FIELD_NAMES.poBox);
    // const addressType = getValueByFieldName(values, FIELD_NAMES.primaryAddress);
    const refernceName = getValueByFieldName(values, FIELD_NAMES.fullNameRefernce);
    const referncePhone = getValueByFieldName(values, FIELD_NAMES.referencePhoneNumber);
    const homeCountryReferenceName = getValueByFieldName(values, FIELD_NAMES.fullNameHomecountry);
    const homeCoutryCode = getValueByFieldName(values, FIELD_NAMES.homeCountryPhoneCountryCode);
    const homeCoutryPhone = getValueByFieldName(values, FIELD_NAMES.homeCountryPhone);
    const homeCoutryAddressLine1 = getValueByFieldName(values, FIELD_NAMES.homeCountryAddress);
    const homeCoutryAddressLine2 = getValueByFieldName(values, FIELD_NAMES.homeCountryAdditionalAddress);
    const homeCoutryCountry = getValueByFieldName(values, FIELD_NAMES.homeCountryCountry);
    const homeCoutrypinCode = getValueByFieldName(values, FIELD_NAMES.homeCountryPoscode);
    //HOME ADDRESS
    const address1Home = getValueByFieldName(values, FIELD_NAMES.addressLine1Home);
    const address2Home = getValueByFieldName(values, FIELD_NAMES.addressLine2Home);
    const landmarkHome = getValueByFieldName(values, FIELD_NAMES.nearestLandmark);
    const emiratesHome = getValueByFieldName(values, FIELD_NAMES.residentialEmirateHome);
    const countryHome = getValueByFieldName(values, FIELD_NAMES.homeCountryCountryHome);
    const pinCodeHome = getValueByFieldName(values, FIELD_NAMES.poBoxHome);
    // const addressType = getValueByFieldName(values, FIELD_NAMES.primaryAddress);
    const refernceNameHome = getValueByFieldName(values, FIELD_NAMES.fullNameRefernceHome);
    const referncePhoneHome = getValueByFieldName(values, FIELD_NAMES.referencePhoneNumberHome);
    const homeCountryReferenceNameHome = getValueByFieldName(values, FIELD_NAMES.fullNameHomecountryHome);
    const homeCoutryCodeHome = getValueByFieldName(values, FIELD_NAMES.homeCountryPhoneCountryCodeHome);
    const homeCoutryPhoneHome = getValueByFieldName(values, FIELD_NAMES.homeCountryPhoneHome);
    const homeCoutryAddressLine1Home = getValueByFieldName(values, FIELD_NAMES.homeCountryAddressHome);
    const homeCoutryAddressLine2Home = getValueByFieldName(values, FIELD_NAMES.homeCountryAdditionalAddressHome);
    const homeCoutryCountryHome = getValueByFieldName(values, FIELD_NAMES.homeCountryCountryHome);
    const homeCoutrypinCodeHome = getValueByFieldName(values, FIELD_NAMES.homeCountryPoscodeHome);


    if (step === STEP_NAMES.employment) {

        return {
            "i_cif": cifnumber,
            "i_address1": address1,
            "i_address2": address2,
            "i_landmark": landmark,
            "i_street": "",
            "i_city": emirates,
            "i_country": typeof country !== 'undefined' ? country : "UAE",
            "i_postal_code": typeof pinCode !== 'undefined' ? pinCode : "",
            "i_primary_flag": "",
            "i_address_type": "BUSINESS",
            "i_attribute1": "",
            "i_attribute2": "",
            "i_attribute3": "",
            "i_attribute4": "",
            "i_attribute5": "",
            "i_attribute6": "",
            "i_attribute7": "",
            "i_attribute8": "",
            "i_attribute9": "",
            "i_attribute10": "",
            "i_attribute11": "",
            "i_attribute12": "",
            "i_attribute13": "",
            "i_attribute14": "",
            "i_attribute15": ""

        };

    }
    if (step === STEP_NAMES.creditCardLimitReview || step === STEP_NAMES.appointment || step === STEP_NAMES.appointmentDigital) {


        return {
            "i_cif": cifnumber,
            "i_address1": address1Home,
            "i_address2": address2Home,
            "i_landmark": landmarkHome,
            "i_street": "",
            "i_city": emiratesHome,
            "i_country": typeof countryHome !== 'undefined' ? countryHome : "UAE",
            "i_postal_code": typeof pinCodeHome !== 'undefined' ? pinCodeHome : "",
            "i_primary_flag": "",
            "i_address_type": addressTypeHome,
            "i_attribute1": refernceName,
            "i_attribute2": referncePhone,
            "i_attribute3": homeCountryReferenceName,
            "i_attribute4": homeCoutryCode,
            "i_attribute5": homeCoutryPhone,
            "i_attribute6": homeCoutryAddressLine1,
            "i_attribute7": homeCoutryAddressLine2,
            "i_attribute8": typeof homeCoutryCountry !== 'undefined' ? homeCoutryCountry : "",
            "i_attribute9": typeof homeCoutrypinCode !== 'undefined' ? homeCoutrypinCode : "",
            "i_attribute10": "",
            "i_attribute11": "",
            "i_attribute12": "",
            "i_attribute13": "",
            "i_attribute14": "",
            "i_attribute15": ""

        };

    }
};


export default {
    async createAddress(currentStep, callbacks) {
        const { form } = currentStep;
        let response = false;
        response = await callApi({
            callbacks,
            form,
            formElement: currentStep,
            apiCall: createAddressRepository.createAddress,
            payload: getPayload(),
        });

    }
};